import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-brand">
          {/* Espacio para logo PNG - añadir después */}
          <img
            src="/logo.png"
            alt="Ecolimpieza Perú A&G"
            className="footer-logo"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'block';
            }}
          />
          <h3 className="footer-logo-fallback">Ecolimpieza Perú A&G</h3>
          <p>
            Soluciones de limpieza profesional y ecológica para empresas
            e instituciones en todo el Perú.
          </p>
          <div className="social-links">
            <a href="#" className="social-link" aria-label="Facebook">f</a>
            <a href="#" className="social-link" aria-label="LinkedIn">in</a>
            <a href="#" className="social-link" aria-label="Email">✉</a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Servicios</h3>
          <ul>
            <li><Link to="/servicios/limpieza">Limpieza</Link></li>
            <li><Link to="/servicios/auxiliares">Servicios Auxiliares</Link></li>
            <li><Link to="/servicios/mantenimiento">Mantenimiento e Ingeniería</Link></li>
            <li><Link to="/servicios/rrhh">Recursos Humanos</Link></li>
            <li><Link to="/servicios/sociosanitarios">Servicios Sociosanitarios</Link></li>
            <li><Link to="/servicios/soluciones-integrales">Soluciones Integrales</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Empresa</h3>
          <ul>
            <li><Link to="/nosotros">Sobre Nosotros</Link></li>
            <li><Link to="/nosotros">Nuestros Valores</Link></li>

          </ul>
        </div>

        <div className="footer-section">
          <h3>Contacto</h3>
          <ul>
            <li>📧 sydiez@ecolimpiezaag.com</li>
            <li>📱 +51 944 170 506</li>
            <li>📍 Perú</li>
            <li>🕒 Lun - Sáb: 7:00 - 19:00</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Ecolimpieza Perú A&G S.A.C. Todos los derechos reservados.</p>
        <p>Dominio: ecolimpiezaag.com</p>
      </div>
    </footer>
  );
};

export default Footer;
